import React, { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { fetchDeviceFormResponse } from "js/Api/index";
import moment from 'moment';
import ResponsesList from "../../../Forms/ResponsesList";

const DeviceForms = ({ user }) => {

    const [loading, setLoading] = useState(true);
    const [FormResponse, setFormResponse] = useState([]);

    const getDeviceForms = async () => {
        setLoading(true);
        const result = await fetchDeviceFormResponse(user.id);

        if (result.success) {
            setFormResponse(result.data);
        } else {
            console.error('Failed to fetch forms:', result.error);
            toast.error('Failed to fetch forms');
        }
        setLoading(false);
    }

    const handleBackToResponses = () => {
        setSelectedResponse(null);
    };

    const handleRowClick = (item) => {
        setSelectedResponse(item);
        //var obj = { id: item.id, template_id: item.TemplateType !== "" ? item.form_Id : null, form_id: item.TemplateType !== "" ? null : item.form_Id }

        //localStorage.setItem('form_response', JSON.stringify(obj));
        //let url = window.location.href.split("#")[0] + "#forms";
        //window.location.href = url;
        //window.location.reload();
    }

    const [selectedResponse, setSelectedResponse] = useState(null);

    useEffect(() => {
        getDeviceForms();
    }, []);

    return (
        <div>
            {selectedResponse ?
                <ResponsesList selectedResponse={selectedResponse} handleBackClick={handleBackToResponses} Parent="device-list" />
            :
            <>
                <table className="table table-hover">
                    <caption style={{ captionSide: 'top', textAlign: 'center', marginRight: '160px' }}>
                        <h3>Forms</h3>
                    </caption>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Form type</th>
                            <th>Start date</th>
                            <th>End date</th>
                            <th>Date responded</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="5" className="text-center">
                                    Loading forms...
                                </td>
                            </tr>
                        ) : FormResponse.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="text-center">
                                    No forms found
                                </td>
                            </tr>
                        ) : (
                            FormResponse.map((form) => (
                                <tr onClick={() => handleRowClick(form)} key={form.Id}>
                                    <td>{form.formName}</td>
                                    <td>{form.formType === "general" && "General"}
                                        {form.formType === "checklist" && "Checklist"}
                                        {form.formType === "single-question" && "Single-Question"}
                                    </td>
                                    <td>{moment(form.startTime).format('DD/MM/YYYY hh:mm a')}</td>
                                    <td>{moment(form.endTime).format('DD/MM/YYYY hh:mm a')}</td>
                                    <td>{moment(form.createdAt).format('DD/MM/YYYY hh:mm a')}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </>
            }
        </div>
    );
};

export default DeviceForms;